export enum ContextPart {
    Sites = 'Sites',
    Channels = 'Channels',
    RelocationLimits = 'RelocationLimits',
}
